import { render } from "./Submit.vue?vue&type=template&id=8531b26a&scoped=true"
import script from "./Submit.vue?vue&type=script&lang=js"
export * from "./Submit.vue?vue&type=script&lang=js"

import "./Submit.vue?vue&type=style&index=0&id=8531b26a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8531b26a"

export default script